/* eslint-disable */
import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  Paper,
  TablePagination,
  TableRow,
  Checkbox,
  Fab,
} from '@mui/material';
import Row from './Row';
import style from './style';
import { colors } from 'Constants/Colors';
import useTranslation from 'Hooks/useTranslation';
import LoadingContainer from 'Containers/LoadingContainer';

const { tableContainerStyle, tableStyle, tableHead, tableCellStyle, StyledTableCell, tablePaginationStyle } = style;

export default function SelectTable({
  headers = [],
  information = [],
  limit = information.length,
  thereIsComponent = null,
  floatingMessage = '',
  selectedRows = [],
  checkbox = true,
  event = null,
  selectAllEvent = null,
  selectAllStatus = null,
  isLoading,
}) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [count, setCount] = useState(information.length);
  const { t2 } = useTranslation('Table');

  if (count != information.length) {
    setCount(information.length);
    setPage(0);
  }

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  if (information.length === 0) return <LoadingContainer isLoading={isLoading}>{t2('NoData')}</LoadingContainer>;

  return (
    <div>
      <TableContainer component={Paper} style={tableContainerStyle} elevation={0}>
        <Table sx={tableStyle} stickyHeader>
          <TableHead sx={tableHead}>
            <TableRow>
              {checkbox ? (
                <StyledTableCell align="center">
                  <Checkbox edge="start" checked={selectAllStatus} onClick={selectAllEvent} />
                </StyledTableCell>
              ) : null}

              {headers.map((header, index) => (
                <StyledTableCell key={index} align="center" style={tableCellStyle}>
                  {header}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody style={{ maxHeight: '40vh', overflow: 'auto' }}>
            {information.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
              const id = row[0] + index;
              const indx = information.indexOf(row);
              return (
                <Row
                  key={id}
                  index={indx}
                  row={row}
                  limit={limit}
                  thereIsComponent={thereIsComponent}
                  event={() => event(row, indx)}
                  active={row[row.length - 1]}
                  checkbox={checkbox}
                />
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        labelRowsPerPage={t2('Pagination')}
        style={{ marginRight: '1.5rem' }}
        component="div"
        count={count}
        page={page}
        sx={tablePaginationStyle}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      {selectedRows.length !== 0 ? (
        <Fab
          variant="extended"
          size="medium"
          style={{
            position: 'fixed',
            zIndex: '10',
            right: '5vw',
            bottom: '10vh',
            background: colors.GREEN_LEAF,
            textTransform: 'none',
            color: colors.WHITE,
            fontFamily: 'quicksand',
            fontWeight: 'bold',
          }}
        >
          <div
            style={{
              width: '2em',
              height: '2em',
              borderRadius: '50%',
              lineHeight: '2em',
              marginRight: '10px',
              background: colors.GREEN_LEAF_OPACITY,
            }}
          >
            {selectedRows.length}
          </div>
          {floatingMessage}
        </Fab>
      ) : null}
    </div>
  );
}
